import { render, staticRenderFns } from "./FormOffersField.vue?vue&type=template&id=99ca033c&"
import script from "./FormOffersField.vue?vue&type=script&lang=js&"
export * from "./FormOffersField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports